// src/pages/markets/board/board/routes.ts
//
// Every href the board renders comes from here. The card root is a real <a>
// (ctrl-click / middle-click must work), so the SPA route and the anchor href
// have to be the same string — one builder, used for both.

export function eventHref(eventId: string, slug?: string | null): string {
    return `/markets/event/${slug || eventId}`;
}

// Adjust here if the trader view lives on a different path.
export function traderHref(address: string): string {
    return `/markets/trader/${address}`;
}
export function eventMarketHref(
    eventId: string,
    marketId: string,
    slug?: string | null
): string {
    return `${eventHref(eventId, slug)}?markets=${encodeURIComponent(marketId)}`;
}
